import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConstants } from '../../constants/app-constants';
import { InteractorResponse } from '../../models/interactor-response';
import { AbstractUrgencyService } from '../abstract/abstract-urgency-api-service';
import { UrgencyModel } from 'src/app/store/urgency/model';

const baseUrl = `/api/urgencies`;

@Injectable()
export class UrgencyService extends AbstractUrgencyService {
  private http = inject(HttpClient);

  getAll(): Observable<InteractorResponse<UrgencyModel[]>> {
    return this.http.get<InteractorResponse<UrgencyModel[]>>(`${baseUrl}`);
  }
}
